import { Container, Stack, Typography } from "@mui/material";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import AuthContainer from "../../../components/AuthContainer.js";
import BackButton from "../../../components/BackButton/index.js";
import GlobalButton from "../../../components/CustomButton/index.js";

const profileTypes = [
  {
    name: "becomeServiceProvider",
    type: "company",
  },
  {
  name: "becomeCleaner",
    type: "worker",
  },
];

const CompanyProfileType = () => {
  const navigate = useNavigate();

  return (
    <AuthContainer>
      <BackButton
        handleBack={() => {
          navigate("/");
        }}
      />
      <Container sx={{ maxWidth: "520px !important", mt: 4 }}>
        <Stack textAlign={"center"}>
          <Typography variant="auth_primary_text" component={"h1"}>
            {t("registration")}
          </Typography>
          <Typography variant="auth_secondary_text" component={"p"}>
            {t("registrationNote")}
          </Typography>
        </Stack>

        <Stack spacing={1.5} mt={5}>
          {profileTypes.map((val) => (
            <GlobalButton
              key={val.type}
              variant={"outlined"}
              btnText={t(val.name)}
              handleClickBtn={() => {
                navigate("/login", { state: { type: val.type } });
              }}
              styleProps={{
                fontWeight: 500,
                fontSize: "1rem",
                width: "100%",
              }}
              hoverProperties={{
                backgroundColor: "primary.main",
                color: "custom.white",
              }}
            />
          ))}
        </Stack>
      </Container>
    </AuthContainer>
  );
};

export default CompanyProfileType;
